export const PortfolioPermissions = {
  ViewandsearchinPropertyManagementPortfolio: {
    permissionsId: '1ec4f88d-0fff-4c99-c9d3-08d94f66fc61',
    permissionsName: 'View and search in  Property Management Portfolio',
    componentsId: null,
    components: null
  },

  CreatePortfolio: {
    components: null,
    componentsId: null,
    permissionsId: '5c461805-9d20-4bf8-9334-08d967db92be',
    permissionsName: 'Create Portfolio'
  },
  EditPortfolio: {
    components: null,
    componentsId: null,
    permissionsId: '7a9ed47a-f4b8-4ab2-0d77-08d96c602a6b',
    permissionsName: 'Edit Portfolio'

  }


};
